exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".FiveBlockLinksForDriving-list{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-ms-flex-wrap:wrap;flex-wrap:wrap}.FiveBlockLinksForDriving-item{border-width:1px;border-style:solid;width:33.33333%}.FiveBlockLinksForDriving-item:first-child,.FiveBlockLinksForDriving-item:nth-child(2){border-width:1px;border-style:solid;width:50%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/sass-loader/lib/loader.js!./src/components/contents/FiveBlockLinksForDriving/FiveBlockLinksForDriving.m.scss
// module id = 926
// module chunks = 26